<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Application Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-select expanded placeholder="Certification" v-model="application.cert_id">
                        <option :value="c.id" v-for="c in certs">{{ c.title }}</option>
                    </b-select>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="application.title"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Description">
                        <quill-editor v-model="application.description" ref="descriptionEditor" :options="editorOptions" class="has-background-white content"/>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import {client as http} from "@/http_client";

    export default {
        name: 'ApplicationForm',
        props: {
            application: {
                type: Object,
                required: true
            },
            card: {
                type: Object,
                required: true
            }
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                certSelect: null,
                certs: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {
            loadCerts(force) {
                this.$emit('loading', true);

                http.get('certs/', {force}).then(response => {
                    this.certs = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            }
        },
        mounted: function() {
            this.loadCerts();
        }
    };
</script>

<style lang="scss" scoped>
    .drag-handle {
        cursor: ns-resize;
    }
</style>
